import { useEffect, useRef } from 'react';
import useAlert from '../../../contexts/alert';
import useCream from '../../../contexts/cream';
import {
  API_CreamTransaction,
  CountDown,
  CreamTransactionTypes,
  TransactionStatuses,
  useCountDown
} from 'shared';
import useUserData from '../../../contexts/userData';

export const TransactionsUpdater = () => {
  const alert = useAlert();
  const { loggedIn } = useUserData();
  const {
    getTransactionsHistory,
    txHistory,
    updatePendingTransaction,
    setUpdatePendingLoading
  } = useCream();
  const timer = useRef<CountDown>(useCountDown());
  const active = useRef<boolean>(false);

  useEffect(() => {
    if (loggedIn) {
      getTransactionsHistory();
    } else {
      stopTimerIfNeeded();
    }
  }, [loggedIn]);

  useEffect(() => {
    if (filter(txHistory).length > 0) {
      startTimerIfNeeded();
    } else {
      stopTimerIfNeeded();
    }
  }, [txHistory]);

  const filter = (raw: API_CreamTransaction[]) => {
    return raw.filter((tx) => tx.status === TransactionStatuses.PENDING);
  };

  const stopTimerIfNeeded = () => {
    if (active.current) {
      timer.current.stop();
      active.current = false;
    }
  };

  const startTimerIfNeeded = (needed?: boolean) => {
    if (!active.current || needed) {
      timer.current.start(5, null, updateTransactions);
      active.current = true;
    }
  };

  const updateTransactions = async () => {
    const pending = filter(txHistory);
    if (pending.length < 0) return;
    setUpdatePendingLoading(true);
    const result = await Promise.all(
      pending.map(async (t) => {
        try {
          const status = await updatePendingTransaction(t.hash);
          switch (status) {
            case TransactionStatuses.CONFIRMED:
              {
                alert.show(
                  `Transaction is completed. You ${
                    t.type === CreamTransactionTypes.BUY ? 'received' : 'sold'
                  } ${t.creamAmount} cream`
                );
              }
              break;
            case TransactionStatuses.FAILED:
              {
                alert.showError(
                  `Transaction is failed. ${
                    t.type === CreamTransactionTypes.SELL
                      ? `You got ${t.creamAmount} cream back`
                      : ''
                  }`
                );
              }
              break;
            default:
              return false;
          }
          return true;
        } catch (err) {
          return false;
        }
      })
    );
    setUpdatePendingLoading(false);
    const pendingLeft = result.filter((r) => !r).length;
    if (pendingLeft > 0) startTimerIfNeeded(true);
  };

  return null;
};
